/**
 * Convierte URLs de imágenes almacenadas en el bucket S3 de Ciencuadras
 * (https://www-img-cc.s3.amazonaws.com/...) a la URL optimizada del CDN
 * (https://images.ciencuadras.com/<Base64>).
 */

const AWS_S3_PREFIX = "https://www-img-cc.s3.amazonaws.com/";
const BUCKET_NAME = "www-img-cc";
const CDN_BASE_URL = "https://images.ciencuadras.com";

export function transformCdnImageUrl(url: string | undefined | null): string {
  if (!url || typeof url !== "string") return "";

  const trimmedUrl = url.trim();

  // Verificar si la URL corresponde al S3 de www-img-cc
  if (trimmedUrl.startsWith(AWS_S3_PREFIX)) {
    const key = trimmedUrl.slice(AWS_S3_PREFIX.length);
    if (!key) return trimmedUrl;

    const jsonPayload = JSON.stringify({ bucket: BUCKET_NAME, key });

    let base64String = "";
    if (typeof btoa === "function") {
      base64String = btoa(jsonPayload);
    } else if (typeof Buffer !== "undefined") {
      base64String = Buffer.from(jsonPayload).toString("base64");
    } else {
      return trimmedUrl;
    }

    return `${CDN_BASE_URL}/${base64String}`;
  }

  return trimmedUrl;
}

export function transformCdnImageUrls(urls: any[]): string[] {
  if (!Array.isArray(urls)) return [];
  return urls
    .map((item) => {
      const rawUrl = typeof item === "object" ? (item?.url || item?.src || "") : String(item || "");
      return transformCdnImageUrl(rawUrl);
    })
    .filter(Boolean);
}
